import React, { useEffect } from "react";
import "./blogcard.css";
const BlogHomeCard = (props) => {
  //   console.log(props);
  return (
    <div data-aos="fade-up" data-aos-duration="500" className="cards_div blog_card">
      <div className="row mb_2rem">
        <div className="col-lg-4 col-xs-12 overflow_hider">
          {props.blog.image ? (
            <img src={props.blog.image} width="100%" />
          ) : (
            <img
              src="https://www.independentmediators.co.uk/wp-content/uploads/2016/02/placeholder-image.jpg"
              className="small_blog_img"
              width="100%"
            />
          )}
        </div>
        <div className="col-lg-8 col-xs-12">
          <img
            className="blog_user_image"
            src="https://avatars3.githubusercontent.com/u/31445077?s=460&u=59bc6f20786c76032b87bab0abad5e341c4d5489&v=4"
            width="50px"
          />
          <div className="d-flex">
            {props.blog.category.map((cats) => {
              return (
                <a style={{ textDecoration: "none" }} href={`/category/${cats}`}>
                  {" "}
                  <p className=" tblue ml_2px mb_0 blog_topic alink">{cats.toUpperCase()}</p>
                </a>
              );
            })}
          </div>

          <a
            href={`/blog/${props.blog.slug}`}
            style={{ textDecoration: "none" }}
            className="blog_linker"
          >
            <h1 className="fs15 underline fbold mobile_pl8">{props.blog.title}</h1>
          </a>
          <p className="mobile_pl8">By Rupansh Kapoor</p>
          <p className="fs08 tgrey mobile_pl8">
            <i className="fas fa-clock"></i> 23rd May, 2020 <i class="fas fa-eye"></i>{" "}
            {props.blog.readBy} views
          </p>
        </div>
      </div>
    </div>
  );
};

export default BlogHomeCard;
